module.exports = __webpack_public_path__ + "img/James.757b77c1.png";